var map = {
	"./scoreholio_banner_21bust.png": 39059,
	"./scoreholio_banner_axethrowing.png": 57100,
	"./scoreholio_banner_beerpong.png": 99722,
	"./scoreholio_banner_billiards.png": 97262,
	"./scoreholio_banner_bocce.png": 37440,
	"./scoreholio_banner_cornhole.png": 61146,
	"./scoreholio_banner_darts.png": 55854,
	"./scoreholio_banner_horseshoes.png": 90339,
	"./scoreholio_banner_other.png": 94226,
	"./scoreholio_banner_pickleball.png": 88015,
	"./scoreholio_banner_pong.png": 17812,
	"./scoreholio_banner_popdarts.png": 65183,
	"./scoreholio_banner_tableshuffleboard.png": 53773,
	"./scoreholio_banner_tabletennis.png": 20793,
	"./scoreholio_banner_tennis.png": 65331,
	"./scoreholio_banner_volleyball.png": 15038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83055;